import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'RR NEWS TV FASTEST UPDATE - ताज़ा खबरें, ब्रेकिंग न्यूज़',
  description = 'RR NEWS TV FASTEST UPDATE - देश-विदेश की ताज़ा खबरें, ब्रेकिंग न्यूज़, राजनीति, खेल, मनोरंजन, व्यापार और अन्य समाचार हिंदी में पढ़ें',
  keywords = 'RR News, RR NEWS TV, Fastest Update, आर आर न्यूज़, समाचार, ब्रेकिंग न्यूज़, हिंदी न्यूज़, hindi news, RR NEWS TV FASTEST UPDATE',
  author = 'RR NEWS TV FASTEST UPDATE',
  image = '/images/logo-rr-news.png',
  url = '',
  type = 'website',
  publishedTime,
  modifiedTime,
  section,
  tags = [],
  noIndex = false,
}) => {
  // Construct absolute URL for images and pages
  const baseUrl = window.location.origin;
  const fullUrl = url ? `${baseUrl}${url}` : window.location.href;
  const fullImage = image.startsWith('http') ? image : `${baseUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={fullUrl} />
      
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      {!noIndex && <meta name="robots" content="index,follow" />}

      {/* Open Graph Meta Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content="RR NEWS TV FASTEST UPDATE" />
      <meta property="og:locale" content="hi_IN" />
      
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {section && <meta property="article:section" content={section} />}
      {tags.length > 0 && tags.map((tag, index) => (
        <meta key={index} property="article:tag" content={tag} />
      ))}

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:site" content="@moradabadujala" />
      <meta name="twitter:creator" content="@moradabadujala" />

      {/* Additional Meta Tags */}
      <meta name="language" content="Hindi" />
      <meta name="revisit-after" content="1 days" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
      <meta httpEquiv="content-language" content="hi-IN" />
    </Helmet>
  );
};

export default SEO;


